import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=5f25c692&scoped=true"
import script from "./balance.vue?vue&type=script&lang=ts"
export * from "./balance.vue?vue&type=script&lang=ts"
import style0 from "./balance.vue?vue&type=style&index=0&id=5f25c692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f25c692",
  null
  
)

export default component.exports